const _abbreviation = ['st', 'nd', 'th', 'th'];

export const flattenPrivilegeCategory = (privilegeCategory = []) => {
    const result = {
        cat_id_1st: '',
        cat_id_2nd: '',
        cat_id_3th: '',
        cat_name_1st: '',
        cat_name_2nd: '',
        cat_name_3th: '',
    };

    if (!privilegeCategory) {
        return result;
    }

    privilegeCategory.forEach((category, index) => {
        const { name, categoryId } = category;
        const idKey = `cat_id_${index + 1}${_abbreviation[index]}`;
        const nameKey = `cat_name_${index + 1}${_abbreviation[index]}`;
        result[idKey] = categoryId;
        result[nameKey] = name;
    });

    return result;
};
